import { BatchMailingType } from '../models';

export const ECOMMERCE_POSTAL_DELIVERY_TYPE = new Set<BatchMailingType>([
  'ecommerce_economical',
  'ecommerce_standard',
  'ecommerce_elite',
  'ecommerce_express',
  'ecommerce_light',
  'ecommerce_optima',
]);
